const api = {
    appbox: {
        baseURL:
            import.meta.env.VITE_APP_APPMAX_API_APPBOX_URL ||
            'http://localhost:8082',
    }
}

export default api
